var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: "25",
    cy: "25",
    r: "25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M28.65 8.8a16.15 16.15 0 1 1-9.16 29.45H6.33a1.42 1.42 0 0 1-.2-2.84l.2-.01h10c-.74-.87-1.39-1.83-1.93-2.85h-4.28a1.42 1.42 0 0 1-.2-2.84l.2-.01h3.09a16.15 16.15 0 0 1 3.13-15.2H8.22a1.43 1.43 0 0 1-.19-2.84l.2-.01h11.26c2.6-1.8 5.76-2.85 9.16-2.85zm0 2.85a13.3 13.3 0 1 0 0 26.6 13.3 13.3 0 0 0 0-26.6zm0 2.85a10.45 10.45 0 1 1 0 20.9 10.45 10.45 0 0 1 0-20.9zm2.2 14.66a4.73 4.73 0 0 1-4.37.01l-2.08 2.08a7.57 7.57 0 0 0 8.53 0l-2.09-2.09zm-9.8-4.2c0 1.58.5 3.06 1.32 4.28l2.08-2.07a4.73 4.73 0 0 1-.01-4.42l-2.07-2.07a7.57 7.57 0 0 0-1.32 4.28zm13.9-4.26l-2.08 2.08a4.73 4.73 0 0 1 0 4.36l2.08 2.09a7.57 7.57 0 0 0 0-8.53zm-6.3 2.35a1.9 1.9 0 1 0 0 3.8 1.9 1.9 0 0 0 0-3.8zm0-5.7c-1.58 0-3.05.49-4.27 1.32l2.07 2.07a4.73 4.73 0 0 1 4.42 0l2.07-2.07a7.57 7.57 0 0 0-4.28-1.32z"
  })));
});